import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  ContentDisplay,
  HeadingDisplay,
  ListDisplay
} from '@warrenbrasil/nebraska-web';

import { PortabilityRequest } from '@/modules/trade/services/portability';

interface Props {
  portability: PortabilityRequest;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PortabilityCard',
  props: {
    portability: null
  },
  setup(__props: any) {

const props = __props as {
  portability: PortabilityRequest;
}



const router = useRouter();

const custodianInitialChar = computed(() => {
  return props.portability.custodian.name[0];
});

const footerHref = computed(() => {
  return router.resolve({
    name: 'portabilityRequestDetails',
    params: { id: props.portability.id }
  }).href;
});

return { __sfc: true,props, router, custodianInitialChar, footerHref, ContentDisplay, HeadingDisplay, ListDisplay }
}

})